import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  return <AnimatePresence data-id="element-119">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-brand-black/60 backdrop-blur-sm z-50" data-id="element-120" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-121">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col pointer-events-auto" data-id="element-122">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-123">
                <h2 className="text-2xl font-heading font-bold text-brand-black" data-id="element-124">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-brand-red hover:bg-red-50 rounded-full transition-colors" data-id="element-125">
                  <X className="w-6 h-6" data-id="element-126" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto" data-id="element-127">
                <div className="prose prose-blue max-w-none" data-id="element-128">
                  {content.split('\n').map((paragraph, index) => <p key={index} className="mb-4 text-gray-700 leading-relaxed" data-id="element-129">
                      {paragraph}
                    </p>)}
                </div>
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-xl flex justify-end" data-id="element-130">
                <button onClick={onClose} className="px-6 py-2 bg-brand-blue text-white font-bold rounded-md hover:bg-blue-900 transition-colors" data-id="element-131">
                  Close
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}